export interface CareerChapter {
  id: string;
  name: string;
  logo: string;
  title: string;
  content: string;
  image?: string;
}

export const careerChapters: CareerChapter[] = [
  {
    id: "crmified-llc",
    name: "CRMified LLC",
    logo: "/images/career/CRMified.png",
    title: "April 2021 — Present | Director, Delivery & Innovation",
    content: "This is the chapter in my IT Career which I am still writing. It's a new Role and Responsibility which I will be going to execute, I am super excited about it and I am sure will be able to prove myself again in this position as well...",
    image: "/images/career/CRMified_Team.png"
  },
  {
    id: "appronex-it-solutions",
    name: "Appronex IT Solutions",
    logo: "/images/career/Appronex.png",
    title: "April 2015 — March 2021 | Cloud Solution Architect",
    content: "This was another chapter in my career where I spent 6 years, joined as Team Lead, and went out with an Architect title. This was the time when I excel my knowledge more & more, and got exposure to working with numerous projects and clients.",
    image: "/images/career/Appronex_Team.png"
  },
  {
    id: "appirio-cloud-solutions",
    name: "Appirio Cloud Solutions",
    logo: "/images/career/Appirio.png",
    title: "December 2013 — February 2015 | Salesforce Consultant",
    content: "It was great to be part of the company directly for which I have worked as an OffShore team during my journey with MetaCube, we were 100+ employees who were transferred from MetaCube to Appirio's Indian entity and become part of the family.",
    image: "/images/career/Appirio_Team.png"
  },
  {
    id: "metacube-software",
    name: "MetaCube Software",
    logo: "/images/career/Metacube.png",
    title: "September 2011 — December 2013 | Salesforce Developer",
    content: "This time is what I consider a turning point in my career as in MetaCube I got a chance to explore the Salesforce eco-system, here only I learned the Salesforce Configuration and Development. During my stay, I also excel my self in Data Migration & Integrations.",
    image: "/images/career/Metacube_Team.png"
  },
  {
    id: "hcl-infosystems",
    name: "HCL Infosystems",
    logo: "/images/career/HCL.png",
    title: "July 2010 — September 2011 | Java Developer",
    content: "Worked as a Java Developer on a \"Core Banking Solution (CBS)\" application named \"BancMate\". It was my first company that believed in me when I was fresher and groomed me to proudly call myself an IT Professional.",
    image: "/images/career/HCL_Team.png"
  },
  {
    id: "btech-computer-science",
    name: "B.Tech. Computer Science",
    logo: "/images/career/RTU.png",
    title: "July 2006 — June 2010 | Student",
    content: "This is where it has begun, I did my B.Tech. (Computer Science) degree from Rajasthan Technical University, Kota. This is the course where I developed my passion for computer programming, I must say I still love to write code in C/C++ & Java.",
    image: "/images/career/BTech2006-2010.png"
  }
];

